import { gql } from '@apollo/client';

const submitFalseDataMutation = gql`
    mutation reportProduct(
        $name: String!
        $customerNumber: String!
        $username: String!
        $emailAddress: String!
        $sku: String!
        $productName: String!
        $message: String!
        $language: String!
        $url: String!
        $store: ID
    ) {
        reportProduct(
            name: $name
            customerNumber: $customerNumber
            username: $username
            emailAddress: $emailAddress
            sku: $sku
            productName: $productName
            message: $message
            language: $language
            url: $url
            store: $store
        )
    }
`;

export default submitFalseDataMutation;
